var App = {
    init: function () {
        this.scripts();
    },
    loaded: function () {},
    scripts: function () {
        // Is touch device?

        if ('ontouchstart' in window || window.navigator.MaxTouchPoints > 0 || window.navigator.msMaxTouchPoints > 0) {
            document.body.classList.add('touch');
        } else {
            document.body.classList.add('no-touch');
        }

        window.addEventListener(
            'message',
            function (event) {
                if (event.origin !== 'https://projects.reiven.eu/') return; // Replace with the actual domain of the iframe
                document.getElementById('taltechResultsIframe').style.height = event.data + 'px';
                console.log(document.getElementById('taltechResultsIframe').height);
            },
            false
        );

        var win = window,
            body = document.body,
            footerCta = document.querySelector('.footer-cta'),
            lastScrollTop = 0,
            delta = 5,
            didScroll = false,
            pageHeader = document.querySelector('.page-header'),
            mainContainer = document.querySelector('.main-container'),
            footer = document.querySelector('.page-footer'),
            section = document.querySelector('.page-footer .section');

        document.querySelectorAll('.parallax').forEach(function (bg) {
            const parent = bg.parentElement;
            const rect = parent.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            // Kui element on ekraanil
            if (rect.top < windowHeight && rect.bottom > 0) {
                const visibleRatio = rect.top / windowHeight; // 0 (alumises servas) kuni 1 (üleval)
                const move = (visibleRatio - 0.5) * -20; // -10% kuni +10%
                bg.style.transform = `translateY(${move}%)`;
            }
        });

        // Add scroll event listener
        win.addEventListener('scroll', function () {
            didScroll = true;
            if (win.pageYOffset >= 50) {
                body.classList.add('page-scrolled');
            } else {
                body.classList.remove('page-scrolled');
            }
            document.querySelectorAll('.parallax').forEach(function (bg) {
                const parent = bg.parentElement;
                const rect = parent.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                // Kui element on ekraanil
                if (rect.top < windowHeight && rect.bottom > 0) {
                    const visibleRatio = rect.top / windowHeight; // 0 (alumises servas) kuni 1 (üleval)
                    const move = (visibleRatio - 0.5) * -20; // -10% kuni +10%
                    bg.style.transform = `translateY(${move}%)`;
                }
            });
        });

        function hasScrolled() {
            var st = win.pageYOffset || document.documentElement.scrollTop;

            if (Math.abs(lastScrollTop - st) <= delta) return;

            if (st > lastScrollTop && st > 1) {
                // Scroll Down
                if (pageHeader) {
                    pageHeader.classList.remove('nav-down');
                    pageHeader.classList.add('nav-up');
                }
            } else {
                // Scroll Up
                if (st + win.innerHeight < document.documentElement.scrollHeight) {
                    if (pageHeader) {
                        pageHeader.classList.remove('nav-up');
                        pageHeader.classList.add('nav-down');
                    }
                }
            }

            lastScrollTop = st;
        }

        function checkScroll() {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
            requestAnimationFrame(checkScroll);
        }

        // Start the loop
        checkScroll();

        document.addEventListener(
            'touchstart',
            function (e) {
                logEvent('touch', e.target);
            },
            {passive: false}
        );

        document.querySelectorAll('.reference-gallery img').forEach((img) => {
            const parent = img.closest('a'); // leiame <a> ümber

            function classifyImage() {
                if (img.naturalWidth && img.naturalHeight && parent) {
                    if (img.naturalHeight > img.naturalWidth) {
                        parent.classList.add('portrait');
                    } else {
                        parent.classList.add('landscape');
                    }
                }
            }

            if (img.complete) {
                classifyImage();
            } else {
                img.addEventListener('load', classifyImage);
            }
        });
        // Mobile menu

        const menu_wrapper = document.querySelector('.page-header');
        const menu_button = menu_wrapper.querySelector('.menu-btn');

        if (menu_wrapper && menu_button) {
            menu_button.addEventListener('click', function (e) {
                e.preventDefault();
                menu_wrapper.classList.toggle('menu-opened');
                document.body.classList.toggle('menu-opened');
            });

            window.addEventListener('keyup', function (event) {
                if (event.keyCode == 27 && document.body.classList.contains('menu-opened')) {
                    menu_wrapper.classList.remove('menu-opened');
                    document.body.classList.remove('menu-opened');
                }
            });
        }

        // Logger funktsioon
        // function logEvent(type, target) {
        //     const logger = document.querySelector('.logger');
        //     if (logger) {
        //         logger.innerHTML = `
        //             <strong>Sündmus:</strong> ${type}<br>
        //             <strong>Element:</strong> &lt;${target.tagName.toLowerCase()} class="${target.className}"&gt;
        //         `;
        //     }
        // }

        // Touch/click logimine
        // ['click', 'touchstart'].forEach((eventName) => {
        //     document.addEventListener(
        //         eventName,
        //         function (e) {
        //             logEvent(eventName, e.target);
        //         },
        //         {passive: false}
        //     );
        // });

        // To top

        const back_to_top_button = document.querySelector('.back-top');

        if (back_to_top_button) {
            document.querySelector('.back-top').addEventListener('click', function () {
                window.scrollTo(0, 0);
            });
        }
    }
};

document.addEventListener('DOMContentLoaded', function () {
    App.init();
});
window.addEventListener('load', function () {
    App.loaded();
});
